import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import './UploadFiles.css';
import {addFileToProject, getUserFiles,getSharedFiles } from '../api';

const AddProjectFiles = ({ onComplete, onCancel, projectId,projectFileIds }) => {
    const [allFiles, setAllFiles] = useState([]);
    const [selectedExistingFiles, setSelectedExistingFiles] = useState([]);
    const [filterView, setFilterView] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const org = localStorage.getItem('org') || "";
    const [sharedFiles, setSharedFiles] = useState([]);

    useEffect(() => {
        setIsLoading(true);
        fetchAllFiles();
        fetchSharedFiles();
        setIsLoading(false);
      }, []);

    const fetchAllFiles = async () => {
        try {
          const response = await getUserFiles();
          setAllFiles(response.data);
        } catch (error) {
          console.error('Error fetching all files:', error);
        }
      };
      const fetchSharedFiles = async () => {
        try {
            const response = await getSharedFiles();
            const sharedFilesData = response.data.map(file => ({
                ...file,
                isShared: true
            }));
            setSharedFiles(sharedFilesData);
        } catch (error) {
            console.error('Error fetching shared files:', error);
        }
    };
    const getAllFiles = () => {
                return [...allFiles, ...sharedFiles];
           };

    const filteredFiles = getAllFiles().filter(file => {
        // First check if the file is already in the project
        if (projectFileIds.includes(file.id)) {
            return false; // Skip files that are already in the project
        }

        // First apply the view filter
        if (filterView !== 'all') {
            if (file.visibility !== filterView) {
                return false;
            }
        }

        // Then apply the search filter
        if (searchTerm.trim() !== '') {
            return file.name.toLowerCase().includes(searchTerm.toLowerCase());
        }

        return true;
    });

    const handleFileSelection = (event, fileId) => {
        if (event.target.checked) {
          setSelectedExistingFiles(prev => [...prev, fileId]);
        } else {
          setSelectedExistingFiles(prev => prev.filter(id => id !== fileId));
        }
      };

    const handleFileClose = () => {
        setSelectedExistingFiles([]);
        onCancel();
    };
    const handleFileSubmit = async (event) => {
        event.preventDefault();
        if (!projectId) return;

        try {
            if (selectedExistingFiles.length > 0) {
                await Promise.all(selectedExistingFiles.map(fileId =>
                    addFileToProject(projectId, fileId)
                ));
            } else {
                console.error('No file selected');
                return;
            }
            handleFileClose();
            onComplete()
        } catch (error) {
            console.error('Error handling file:', error);
        }
    };

    return (
        <div className="pt-0">
            <Form onSubmit={handleFileSubmit}>
                {/* New filter and search section */}
                <div className="modal-body bg-light border-bottom pt-0">
                    <div className="row pt-1">
                        <div className="col-6">
                            <Form.Select
                                id="viewFilter"
                                value={filterView}
                                onChange={(e) => setFilterView(e.target.value)}
                            >
                                <option value="all">View All</option>
                                <option value="private">Private</option>
                                <option value="global">Public</option>
                            </Form.Select>
                        </div>
                        <div className="col-6">
                            <Form.Control
                                type="text"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <Form.Group className="mb-1">
                    <Form.Label>Select Files to Add</Form.Label>
                    {isLoading ? (
                        <p>Loading files...</p>
                    ) : filteredFiles.length === 0 ? (
                        <p className="text-muted">No available files match your criteria.</p>
                    ) : (
                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            {filteredFiles.map(file => (
                                <Form.Check
                                    key={file.id}
                                    type="checkbox"
                                    id={`file-${file.id}`}
                                    label={`${file.name} (${file.visibility} ${(file?.isShared) ? "shared" : ""}  )`}
                                    onChange={(e) => handleFileSelection(e, file.id)}
                                    checked={selectedExistingFiles.includes(file.id)}
                                />
                            ))}
                        </div>
                    )}
                </Form.Group>
                <div className="mt-3  d-flex gap-3">
                    <Button variant="secondary" onClick={handleFileClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit" disabled={selectedExistingFiles.length === 0}>
                        Add Files to Project
                    </Button>
                </div>
            </Form>
        </div>
    );


};

export default AddProjectFiles;